import { toast } from "react-toastify";
import { API_INCIDENCIAS } from "../views/MainLayout/components/shared/services/incidencias";
import { API_ENVIOS } from "../views/MainLayout/components/shared/services/envios";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const incidenciasReducer = (state = {}, action) => {
    switch(action.type){
        case "incidencias/fullfilled": {
            return action.payload;
        }
        case "incidencias/set-estado": {
            const newIncidencias = state.incidencias.items;
            const incidencia = newIncidencias.find(i => i.numero === action.payload.incidencia);
            const incidenciaEnvioIndex = incidencia.envios.findIndex(e => e.codigo_transporte === action.payload.envio);
            incidencia.envios[incidenciaEnvioIndex].estado = action.payload.estado;
            const indexIncidencia = newIncidencias.findIndex(i => i.numero === action.payload.incidencia);
            newIncidencias[indexIncidencia].splice(indexIncidencia, 1, incidencia);

           return {
            ...state,
            secciones: newIncidencias
           }
        }
        default:
            return state
    }
}

export const fetchIncidencias = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_INCIDENCIAS.getIncidencias(page, search)
        const data = await response.data;

        if(search?.includes('search') && !search?.includes('seccion')) {
            const activeSection = data?.secciones.reduce((prev, current) => (prev.total_items > current.total_items) ? prev : current)
            
            if(activeSection) {
                localStorage.setItem('incidencias-tab', activeSection.item);
            }
        }

        dispatch({ type: 'incidencias/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const removeIncidencia = (incidenciaId) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_INCIDENCIAS.deleteIncidencia(incidenciaId)
        
        if(response && response.success) {
            toast.success(response.message);
        }
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const cambiarAactiva = (incidenciaId) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_INCIDENCIAS.marcarComoActiva(incidenciaId)

        if(response && response.success) {
            toast.success(response.message);
        }
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const cambiarAfinalizada = (incidenciaId) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_INCIDENCIAS.marcarComoFinalizada(incidenciaId)

        if(response && response.success) {
            toast.success(response.message);
        }
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const cambiarAfinanzas = (incidenciaId) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_INCIDENCIAS.marcarComoFinanzas(incidenciaId)

        if(response && response.success) {
            toast.success(response.message);
        }
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const obtenerEstado = (numSeguimiento, transportistaId) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_ENVIOS.getHermesStatus(numSeguimiento)
        const data = await response.data;

        if(response && response.success) {
            dispatch({type: 'loading/set', payload: false});
            dispatch({type: "incidencias/set-estado", payload: data});
            toast.success(response.message);
        }
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}